import {Draggable, gsap, InertiaPlugin} from "gsap/all";
import {FaceLandmarker, FilesetResolver} from "@mediapipe/tasks-vision";
import $ from "jquery";

const imgTest = new Image();
imgTest.src = 'images/camera/temp-camera-test.jpg'; // For a URL

export class SharedCamera {

  constructor({visionEngine}) {
    this.ready = false;

    this.width = app.settings.webcam.width;
    this.height = app.settings.webcam.height;

    this.cameraVideoEl = null;

    this.flippedCanvas = null;
    this.flippedCanvasCtx = null;

    this.outputCanvasEl = null;
    this.outputCanvasElCtx = null;

    this.faceLandmarker = visionEngine;

    this.latestLandmarks = [];
    this.latestFaceBoundingBox = null;
    this.scaledlatestLandmarks = [];
    this.latestScaledFaceBoundingBox = null;

    this.originalZoomFactor = app.settings.webcam.zoom;
    this.zoomFactor = app.settings.webcam.zoom;
    this.cameraPhysicalPosition = app.settings.webcam.physical_position;
    this.currentFaceCenterY = this.height / 2;

    this.isPlaying = false;
    this.debug = false;

    this.crop = this.getDefaultCrop();

    this.init();
  }

  init() {
    this.initCamera();
  }

  async initCamera() {
    this.cameraVideoEl = $("#camera-video").get(0);

    this.flippedCanvas = $("#flipped-camera-view").get(0);
    this.flippedCanvasCtx = this.flippedCanvas.getContext('2d');

    this.outputCanvasEl = $("#camera-view").get(0);
    this.outputCanvasElCtx = this.outputCanvasEl.getContext('2d');

    const stream = await navigator.mediaDevices.getUserMedia({
      video: {
        facingMode: "user",
        width: {ideal: app.settings.webcam.width},
        height: {ideal: app.settings.webcam.height},
      }, audio: false
    });


    this.cameraVideoEl.onloadeddata = () => {

      requestAnimationFrame(() => {
        this.drawCameraToOffCanvas()
      });

      this.play();

    };

    this.cameraVideoEl.srcObject = stream;
    // await this.cameraVideoEl.play();


    // this.drawCameraToCanvas();
  }

  updateFaceLandmarks() {
    this.latestLandmarks = this.detectFace();
    this.latestFaceBoundingBox = this.getFaceBoundingBox(this.latestLandmarks);

    this.scaledlatestLandmarks = this.latestLandmarks.map(p => {
      const scaledPosition = {
        x: map(p.x * this.height, this.crop.x, this.crop.x + this.crop.w, 0, 1),
        y: map(p.y * this.width, this.crop.y, this.crop.y + this.crop.h, 0, 1),
        z: p.z * this.zoomFactor,
      }
      return {
        ...p,
        ...scaledPosition
      }
    });

    this.latestScaledFaceBoundingBox = this.getFaceBoundingBox(this.scaledlatestLandmarks);
  }

  // getFaceBoundingBox() {
  //   if (!this.latestLandmarks || this.latestLandmarks.length === 0) return null;
  //
  //   // To speed things up, we can directly use the 4 farthest points as we know them already
  //
  //   let xMin = 1, yMin = 1, xMax = 0, yMax = 0;
  //
  //   for (const lm of this.latestLandmarks) {
  //     xMin = Math.min(xMin, lm.x);
  //     yMin = Math.min(yMin, lm.y);
  //     xMax = Math.max(xMax, lm.x);
  //     yMax = Math.max(yMax, lm.y);
  //   }
  //
  //   xMin = Math.max(0, xMin);
  //   yMin = Math.max(0, yMin);
  //   xMax = Math.min(1, xMax);
  //   yMax = Math.min(1, yMax);
  //
  //   let values = {
  //     x: xMin * this.height,
  //     y: yMin * this.width,
  //     w: (xMax - xMin) * this.height,
  //     h: (yMax - yMin) * this.width,
  //     //   centerX: xMin + ((xMax - xMin) / 2),
  //     //   centerY: yMin + ((yMax - yMin) / 2),
  //   };
  //
  //   values.centerX = values.x + (values.w / 2);
  //   values.centerY = values.y + (values.h / 2);
  //
  //   return values;
  //
  //   // return {
  //   //   x: xMin,
  //   //   y: yMin,
  //   //   w: (xMax - xMin),
  //   //   h: (yMax - yMin),
  //   //   centerX: xMin + ((xMax - xMin) / 2),
  //   //   centerY: yMin + ((yMax - yMin) / 2),
  //   // };
  // }

  getFaceBoundingBox(landmarks) {
    if (!landmarks || landmarks.length === 0) return null;

    // To speed things up, we can directly use the 4 farthest points as we know them already

    let xMin = 1, yMin = 1, xMax = 0, yMax = 0;

    for (const lm of landmarks) {
      xMin = Math.min(xMin, lm.x);
      yMin = Math.min(yMin, lm.y);
      xMax = Math.max(xMax, lm.x);
      yMax = Math.max(yMax, lm.y);
    }

    // xMin = Math.max(0, xMin);
    // yMin = Math.max(0, yMin);
    // xMax = Math.min(1, xMax);
    // yMax = Math.min(1, yMax);

    let values = {
      x: xMin * this.height,
      y: yMin * this.width,
      w: (xMax - xMin) * this.height,
      h: (yMax - yMin) * this.width,
    };

    values.centerX = values.x + (values.w / 2);
    values.centerY = values.y + (values.h / 2);

    return values;
  }

  detectFace(scaled = false) {
    const detection = this.faceLandmarker.detectForVideo(scaled ? this.outputCanvasEl : this.flippedCanvas, performance.now());

    if (detection.faceLandmarks?.length) {
      // We found a face, so let's return the landmarks
      return detection.faceLandmarks[0];
    } else {
      // No face detected, return empty
      return [];
    }
  }

  drawCameraToOffCanvas() {

    // Save the current ctx state
    this.flippedCanvasCtx.save();

    if (this.debug) {
      // DEBUG : Draw local imgTest
      this.flippedCanvasCtx.translate(this.height, 0);
      this.flippedCanvasCtx.rotate(Math.PI / 2);
      this.flippedCanvasCtx.drawImage(imgTest, 0, 0, this.width, this.height);

      // Put the canvas back
      this.flippedCanvasCtx.restore();
    } else {

      // Rotate based on camera physical rotation
      if (app.settings.webcam.rotation == "right") {
        this.flippedCanvasCtx.rotate(-Math.PI / 2);
        this.flippedCanvasCtx.translate(-this.width, 0);
      } else {
        this.flippedCanvasCtx.translate(this.height, 0);
        this.flippedCanvasCtx.rotate(Math.PI / 2);
      }

      // Mirror the video and shift back to place
      // Because of the mirror, we need to shift drawing back
      this.flippedCanvasCtx.scale(1, -1);
      this.flippedCanvasCtx.translate(0, -this.height);

      // Because we've rotated, filp the width and height
      this.flippedCanvasCtx.drawImage(this.cameraVideoEl,
        0, 0, this.width, this.height);


      // Put the canvas back
      this.flippedCanvasCtx.restore();

      // Debug squares
      // if (this.latestFaceBoundingBox !== null) {
      //
      //   this.flippedCanvasCtx.strokeStyle = "lime";
      //   this.flippedCanvasCtx.lineWidth = 5;
      //
      //   this.flippedCanvasCtx.beginPath();
      //   this.flippedCanvasCtx.rect(this.latestFaceBoundingBox.x, this.latestFaceBoundingBox.y, this.latestFaceBoundingBox.w, this.latestFaceBoundingBox.h);
      //   this.flippedCanvasCtx.stroke();
      //
      //   this.flippedCanvasCtx.strokeStyle = "lightblue";
      //   this.flippedCanvasCtx.lineWidth = 2;
      //
      //   this.flippedCanvasCtx.beginPath();
      //   this.flippedCanvasCtx.rect(this.height / 2, this.width / 2, 2, 2);
      //   this.flippedCanvasCtx.stroke();
      //
      //   // Handle the face positioning
      //   // First let's zoom in a bit so we can move the image
      //   // Size of the crop box
      //   const cropW = this.height / this.zoomFactor;
      //   const cropH = this.width / this.zoomFactor;
      //
      //
      //   // Center crop
      //   // We'll center on X but we'll center on Y using the face position
      //   const cropX = (this.height - cropW) / 2;
      //
      //   // If we do not have the face bounding box (aka, noone is there)
      //   //  let's center on Y, otherwise use the face position
      //   let cropY = (this.width - cropH) / 2;
      //
      //   // console.log(this.latestFaceBoundingBox);
      //   const faceCenterY = this.latestFaceBoundingBox.y + (this.latestFaceBoundingBox.h / 2);
      //
      //   this.flippedCanvasCtx.strokeStyle = "red";
      //   this.flippedCanvasCtx.lineWidth = 2;
      //
      //   this.flippedCanvasCtx.beginPath();
      //   this.flippedCanvasCtx.rect(this.latestFaceBoundingBox.x + (this.latestFaceBoundingBox.w / 2), this.latestFaceBoundingBox.y + (this.latestFaceBoundingBox.h / 2), 2, 2);
      //   this.flippedCanvasCtx.stroke();
      //
      //   cropY = faceCenterY - cropW;
      //   cropY = Math.max(0, Math.min(cropY, this.width - cropH));
      //
      //   this.flippedCanvasCtx.strokeStyle = "red";
      //   this.flippedCanvasCtx.lineWidth = 2;
      //
      //   this.flippedCanvasCtx.beginPath();
      //   this.flippedCanvasCtx.rect(cropX, cropY, cropW, cropH);
      //   this.flippedCanvasCtx.stroke();
      // }
    }

    this.updateFaceLandmarks();


    requestAnimationFrame(() => {
      this.drawCameraToOffCanvas()
    });
  }

  drawCameraToCanvas() {
    // This will be the base method to have access to a normalized camera output
    // As the camera is a 16:9 feed with the camera rotated 90deg, we need to flip the canvas context, draw the video and flip it back
    if (!this.isPlaying) {
      // Camera has been stopped so let's stop rendering
      return;
    }

    // Save the current ctx state
    this.outputCanvasElCtx.save();

    // Get default centered (no face detected) crop box
    this.crop = this.getDefaultCrop();

    // console.log(this.latestFaceBoundingBox);
    if (this.latestFaceBoundingBox !== null) {
      const faceCenterY = this.latestFaceBoundingBox.y + (this.latestFaceBoundingBox.h / 2);

      this.crop.y = faceCenterY - this.crop.w;
      this.crop.y = Math.max(0, Math.min(this.crop.y, this.width - this.crop.h));

      // smoothly move to target
      this.currentFaceCenterY += ((this.crop.y - this.currentFaceCenterY) * 0.85); // closer to 0 will be smoother, 1 will be quicker.
    }

    // Because we've rotated, filp the width and height
    this.outputCanvasElCtx.drawImage(this.flippedCanvas,
      this.crop.x, this.currentFaceCenterY, this.crop.w, this.crop.h,
      0, 0, this.height, this.width);


    // this.updateScaledFaceLandmarks();

    // =========== ON SITE DEBUGGING ===========
    // =========== SHOW RECTANGLE AROUND THE FACE + CENTER DOT ===========
    // if (this.latestScaledFaceBoundingBox !== null) {
    //   // Draw rectangle
    //   this.outputCanvasElCtx.strokeStyle = "green";
    //   this.outputCanvasElCtx.lineWidth = 8;
    //   this.outputCanvasElCtx.strokeRect(this.latestScaledFaceBoundingBox.x, this.latestScaledFaceBoundingBox.y, this.latestScaledFaceBoundingBox.w, this.latestScaledFaceBoundingBox.h);
    //
    //   // Draw center dot
    //   this.outputCanvasElCtx.fillStyle = "red";
    //   this.outputCanvasElCtx.beginPath();
    //   this.outputCanvasElCtx.arc(this.latestScaledFaceBoundingBox.centerX, this.latestScaledFaceBoundingBox.centerY, 5, 0, Math.PI * 2);
    //   this.outputCanvasElCtx.fill();
    // }

    // Put the canvas back
    this.outputCanvasElCtx.restore();


    requestAnimationFrame(() => {
      this.drawCameraToCanvas()
    });
  }

  getDefaultCrop() {
    // Handle the face positioning
    // First let's zoom in a bit so we can move the image
    // Size of the crop box
    const w = this.height / this.zoomFactor;
    const h = this.width / this.zoomFactor;

    const wWhenPictureTaken = (this.height / this.originalZoomFactor);

    // Horizontal crop
    // We'll crop based on the settings
    let x = (this.height - w);

    if (this.cameraPhysicalPosition === "left") {
      // start from the left side
      x *= 0;
      x -= (w - wWhenPictureTaken) / 2;
    } else if (this.cameraPhysicalPosition === "right") {
      // start from the right side
      x *= 1;
      x += (w - wWhenPictureTaken) / 2;
    } else {
      // center crop
      x *= 0.5;
    }

    // If we do not have the face bounding box (aka, noone is there)
    //  let's center on Y, otherwise use the face position
    const y = (this.width - h) * 0.5;

    return {w, h, x, y};
  }

  getCanvas() {
    return this.outputCanvasEl;
  }

  play() {
    // This is used to update the camera on the shared canvas
    if (!this.isPlaying) {
      this.isPlaying = true;
      this.drawCameraToCanvas();
    }
  }

  stop() {
    // This is used to stop the rendering of the shared camera when there is no need for changes
    if (this.isPlaying) {
      this.isPlaying = false;
    }
  }

  playMainCamera() {
    // This is used to play the VIDEO feed from the webcam.
    this.cameraVideoEl.play();
  }

  pauseMainCamera() {
    // This is used to pause the VIDEO feed from the webcam.
    // Useful if you still need to handle the canvas but want to freeze the image
    this.cameraVideoEl.pause();
  }

  reset() {
    // console.log("reset shared camera");
    this.zoomFactor = this.originalZoomFactor;
    this.crop = this.getDefaultCrop();
  }

}
